// Dependencies
import React from 'react';
import { useState } from 'react';

// App components
import ButtonFull from '../../global_components/buttons/ButtonFull';
import ButtonOutline from '../../global_components/buttons/ButtonOutline';
import ButtonFormSubmit from '../../global_components/buttons/ButtonFormSubmit';
import InputField from '../../global_components/form_components/InputField';

const RegisterPage = () => {
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    
    const formData = {
      email: e.target.registerEmailAddress.value,
      password: e.target.registerPassword.value,
      fullName: e.target.registerFullName.value,
      department: e.target.registerDepartment.value,
    };

    try {
      const response = await fetch("https://wad-backend.ws381566.remote.ac/register.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        mode: "cors",
      });
      const result = await response.json();
      setStatusMessage(result.message);
      const sleep = ms => new Promise(r => setTimeout(r, ms));
      await sleep(4000)
      if (result.success === true) {
        window.location.href = '/login';
      }
    } catch (error) {
      setStatusMessage(error.message);
    } finally {}
  };

  return (
    <div className='w-full h-full flex flex-col items-center bg-primary bg-[#161C33] px-7 sm:px-20 gap-5'>
      <div className='w-full flex flex-col gap-4 sm:flex-row items-center justify-between px-7 py-5' id='header'>
        <div id='logoContainer' className='text-center sm:text-left'>
          <h2 className="text-2xl font-bold text-white">Don't Get Mugged!</h2>
          <h4 className="text-md font-medium text-[#06BD60] uppercase mt-1">Training co.</h4>
        </div>
        <div className='flex flex-col gap-3 sm:flex-row items-center sm:items-center mt-5 sm:mt-0' id='buttonContainer'>
          <div className='mr-0 sm:mr-4 mb-3 sm:mb-0'>
            <ButtonFull buttonText='Login' navigationURL='/login' />
          </div>
          <div>
            <ButtonOutline buttonText='Register' navigationURL='/register' />
          </div>
        </div>
      </div>
      <div className='flex flex-col items-start bg-white p-5 sm:p-10 w-full max-w-screen-md sm:max-w-lg' id="formContainer">
        <div id='formHeader' className='mb-7 w-full flex flex-col items-start'>
          <h2 className='text-3xl uppercase font-black text-center sm:text-left'>Welcome.</h2>
          <h4 className='text-base mt-2 text-center sm:text-left'>Use this form to register for an account.</h4>
          <h4 className='text-base text-center sm:text-left'>Once approved you will be able to view and book courses.</h4>
          {statusMessage && <h4 className="text-red-500 mt-2 text-center sm:text-left">{statusMessage}</h4>}
        </div>
        <form onSubmit={handleSubmit} className='w-full flex flex-col items-start gap-5'>
          <InputField for='registerEmailAddress' name='registerEmailAddress' labelText='Email address' inputType='email' inputRequired='true' />
          <InputField for='registerPassword' name='registerPassword' labelText='Password' inputType='password' inputRequired='true' />
          <InputField for='registerFullName' name='registerFullName' labelText='Full name' inputType='text' inputRequired='true' />
          <InputField for='registerDepartment' name='registerDepartment' labelText='Department / position' inputType='text' inputRequired='true' />
          <ButtonFormSubmit buttonText='Register' overrideStyles='w-full mt-5' />
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;